module.exports = __webpack_public_path__ + "img/buy0440.0172950a.svg";